import { render, staticRenderFns } from "./MaterialManagement.vue?vue&type=template&id=097d7bb6&"
import script from "./MaterialManagement.vue?vue&type=script&lang=js&"
export * from "./MaterialManagement.vue?vue&type=script&lang=js&"
import style0 from "./MaterialManagement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MaterialManagement.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports